import { render, staticRenderFns } from "./search-list.vue?vue&type=template&id=b153b064&scoped=true&"
import script from "./search-list.vue?vue&type=script&lang=js&"
export * from "./search-list.vue?vue&type=script&lang=js&"
import style0 from "./search-list.vue?vue&type=style&index=0&id=b153b064&prod&lang=scss&"
import style1 from "./search-list.vue?vue&type=style&index=1&id=b153b064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b153b064",
  null
  
)

export default component.exports